import { ReactElement } from "react";

import styles from "./index.module.css";
import { useSettings } from "../../../state/settings";
import Preview from "../../shared/Preview";

export default function Thumbnails(props: {
  preview: string;
  horizontal?: boolean;
}): ReactElement {
  const { settings } = useSettings();

  return (
    <>
      <div
        className={`${styles.thumbnailWrapper} ${
          props.horizontal ? styles.horizontal : styles.vertical
        }`}
      >
        {settings.thumbnailLarge ? (
          <div className={styles.thumbnailLarge}>
            <Preview preview={props.preview} />
          </div>
        ) : undefined}

        {settings.thumbnailMedium ? (
          <div className={styles.thumbnailMedium}>
            <Preview preview={props.preview} />
          </div>
        ) : undefined}

        {settings.thumbnailSmall ? (
          <div className={styles.thumbnailSmall}>
            <Preview preview={props.preview} />
          </div>
        ) : undefined}
      </div>
    </>
  );
}
